<template>
  <div>
    <v-col v-if="list.length > 0">
      <carousel
        :per-page-custom="[
          [280, 1],
          [960, 2],
          [1264, 3],
          [1904, 4],
        ]"
        autoplay
        loop
        :pagination-enabled="false"
      >
        <slide v-for="(item, i) in list" :key="i">
          <img
            :src="'/storage/' + item.image"
            :lazy-src="'/storage/' + item.image"
            style="width: 100%; height: 100%"
            @click="showModel(item)"
          />
        </slide>
      </carousel>
      <!-- Show dialog  -->
      <v-dialog v-model="show" persistent max-width="450" :scrollable="false">
        <v-card class="pa-0">
          <v-card-title>
            <small>{{ activeItem.name | uppercase }}</small> <v-spacer />
            <small>{{ activeItem.price | currency }}</small>
            <v-btn class="mx-2 error--text" icon @click="show = false">
              <v-icon>mdi-close-octagon</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <strong><p v-html="activeItem.description"/></strong>
            <v-img
              :src="'/storage/' + activeItem.image"
              :lazy-src="'/storage/' + activeItem.image"
            />
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- end -->
    </v-col>
    <v-col v-else>
      <v-alert type="info">
        Recored not found !
      </v-alert>
    </v-col>
    <p><strong>Attention : </strong>Coming soon online shopping !</p>
  </div>
</template>
<script>
import { Carousel, Slide } from "vue-carousel";

export default {
  components: {
    Carousel,
    Slide,
  },
  data() {
    return {
      list: [],
      activeItem: {},
      show: false,
    };
  },

  mounted() {
    window.axios.get("/get-shop-items").then((response) => {
      this.$data.list = response.data.list;
    });
  },
  methods: {
    showModel(item) {
      this.$data.activeItem = item;
      this.$data.show = true;
    },
  },
};
</script>
<style type="text/css">
.VueCarousel-slide {
  height: 450px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  font-size: 12px;
  text-align: center;
}
</style>
